import {useCallback} from "react"
import {messagesService} from "@dv5/api"

interface UseMarkdownWidgetUpdateProps {
    canvasId: string
    widgetId: string
}

export function useMarkdownWidgetUpdate({canvasId, widgetId}: UseMarkdownWidgetUpdateProps) {
    const updateData = useCallback((patchedPaths: string[], newData: Record<string, unknown>) => {
        messagesService.send('canvas.change-widget-data', {
            canvasId,
            widgetId,
            patchedPaths,
            data: newData,
        })
    }, [canvasId, widgetId])

    return {updateData}
}
